import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "./context/AuthContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import FloatingCTAs from "./components/FloatingCTAs";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Book from "./pages/Book";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import AirportTransportation from "./pages/AirportTransportation";
import Fleet from "./pages/Fleet";
import Contact from "./pages/Contact";
import ZuberValet from "./pages/ZuberValet";
import ExecutiveChauffeur from "./pages/ExecutiveChauffeur";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function Layout({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [loc.pathname]);

  return (
    <>
      {!isAdmin && <Navigation />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      <FloatingCTAs />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-right" richColors />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/book" element={<Book />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/airport-transportation" element={<AirportTransportation />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/zuber-valet" element={<ZuberValet />} />
              <Route path="/executive-chauffeur" element={<ExecutiveChauffeur />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
